<header class="header row-flex-container">
  <app-avatar [workItemId]="workItem.id" [workItemType]="workItem.type" [title]="title"></app-avatar>

  <div class="visitor-name row-flex-no-grow" title="{{ title }}">
      <span class="visitor-name-text" [attr.data-automation-id]="'bc-header-visitor-name'">{{ title }}</span>
  </div>

  <div class="lane-toggler row-flex-no-shrink" *ngIf="isAssistedSessionAllowed() && showButtons">
    <div class="button-list border-left">
      <button *ngIf="isAbFeatureAvailable"
        class="toggle-btn icon-button start-session"
        (click)="startAssistedBrowsing()"
        [ngClass]="{ 'toggle-btn-active': workItem.hasActiveAssistedBrowsing }"
        [disabled]="isAssistedBrowsingDisabled()"
        data-automation-id="start-assistedbrowsing">
        <svg-icon icon="{{ getAssistedBrowsingIcon() }}"></svg-icon>

        <ng2-tooltip [direction]="'bottom'" [text]="'workWidgetHeader.newAssistedBrowsingTooltip' | translate"></ng2-tooltip>
      </button>

      <button *ngIf="isRcFeatureAvailable"
        class="toggle-btn icon-button start-session"
        (click)="startRCSession()"
        [ngClass]="{ 'toggle-btn-active': workItem.hasActiveRemoteControl && !isVendorRemoteControlEnabled }"
        [disabled]="isRemoteControlButtonDisabled()"
        data-automation-id="start-remotecontrol">
        <svg-icon icon="{{ getRemoteControlIcon() }}"></svg-icon>

        <ng2-tooltip [direction]="'bottom'" [text]="'workWidgetHeader.newRcTooltip' | translate"></ng2-tooltip>
      </button>

      <div *ngIf="isVideoFeatureEnabled">
        <button *ngIf="!videoBeingInitiated" class="toggle-btn icon-button start-session" data-automation-id="video-call-btn"
          [disabled]="!canInitiateVideo" (click)="initiateVideoCall()">
          <svg-icon icon="camera"></svg-icon>
          <ng2-tooltip direction="bottom" [text]="'workWidgetHeader.startVideoCall' | translate"></ng2-tooltip>
        </button>
        <div *ngIf="videoBeingInitiated" class="spinner-wrapper">
          <div data-automation-id="video-call-spinner" class="spinner"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="additional-info row-flex-no-shrink" *ngIf="showButtons" (click)="focusWorkItem()">
    <a *ngIf="!isExpandedMode() && visitor"
       (click)="toggleSelfCollapsed()"
       [attr.data-automation-id]="'bc-header-toggle-collapse-info'">
      <span *ngIf="selfCollapsed" [attr.data-automation-id]="'bc-collapsed-info'">{{ 'workWidgetHeader.showVisitorInfo' | translate }}</span>
      <span *ngIf="!selfCollapsed">{{ 'workWidgetHeader.hideVisitorInfo' | translate }}</span>
    </a>
  </div>

  <lane-buttons *ngIf="(isChatExpanded || isTextChatExpanded || isEmailExpanded) && showButtons"
                [workItemId]="workItem.id"
                [workItemType]="workItem.type"
                [isWorkItemEnded]="workItem.isEnded"
                [isNanorepIntegratedChatWorkItem]="!!workItem.NanorepConfigID"
                [ngClass]="{ 'border-right': workItem.isCollapsible }">
  </lane-buttons>

  <div class="tools row-flex-fix" *ngIf="(!previewMode && workItem.isCollapsible && showButtons) || isDiscussion()">
    <svg-icon class="tools-icon tools-minimize js-close-lane"
              icon="minus"
              (click)="hideLane()"
              title="{{ 'workWidgetHeader.minimizeLabel' | translate }}"
              [attr.data-automation-id]="'bc-minimize-lane'"></svg-icon>

    <svg-icon class="tools-icon js-toggle-lane-size"
              *ngIf="!isDiscussion()"
              icon="{{ getCollapseIconClass() }}"
              (click)="toggleExpandedMode()"
              [attr.data-automation-id]="'bc-collapse-mode-toggle'"></svg-icon>
  </div>
  <div class="tools row-flex-fix" *ngIf="previewMode">
    <svg-icon class="tools-icon tools-expand" icon="expand-arrows" (click)="closeLane()"></svg-icon>
    <svg-icon class="tools-icon tools-collapse" icon="collapse-arrows" (click)="closeLane()"></svg-icon>
    <svg-icon class="tools-icon tools-minimize js-close-lane" icon="x" (click)="closeLane()"></svg-icon>
  </div>
</header>

<app-compact-visitor-info class="visitor-dropdown bc-panel" [attr.data-automation-id]="'VISITOR_INFO_PANEL'" *ngIf="visitor && !isExpandedMode()" [ngClass]="{'closed': isSelfCollapsed()}" [workItemId]="workItem.id" [hidden]="isSelfCollapsed()" [visitor]="visitor"></app-compact-visitor-info>
